import { Icons } from '@shared/components/content/icons';
import Text from '@shared/components/content/text';
import { RepeatableFormRows } from '@shared/components/form/repeatable-form-rows';
import { FormMessage } from '@shared/components/ui/form';
import { Skeleton } from '@shared/components/ui/skeleton';
import { useFormContext } from 'react-hook-form';
import { useOutletContext } from 'react-router-dom';
import SupplyFlowRow from './supply-flow-row';

export default function SupplyFlowForm() {
  const { getFieldState } = useFormContext();
  const context: any = useOutletContext();
  const { supplyFlowUuid, loadingSupplyFlow } = context;
  const fieldState = getFieldState('segments');

  return (
    <div>
      {supplyFlowUuid && loadingSupplyFlow ? (
        <div className="space-y-2">
          <Skeleton className="h-12 w-full rounded-md bg-gray-100" />
          <Skeleton className="h-12 w-full rounded-md bg-gray-100" />
          <Skeleton className="h-12 w-full rounded-md bg-gray-100" />
          <Skeleton className="h-12 w-full rounded-md bg-gray-100" />
        </div>
      ) : (
        <RepeatableFormRows
          name="segments"
          component={SupplyFlowRow}
          showAddButton={false}
          newRowObject={{
            nodeType: 'port',
            distance: '',
            transportMode: '',
            storageDuration: 'not_stored',
            nodeName: '',
          }}
        />
      )}

      <div className="mt-2 flex h-[60px] w-[700px] items-center space-x-3 rounded-md border-2 border-primary-600 bg-gray-00 px-4 py-2">
        <Icons.factory className="size-6 text-primary-600" />
        <div className="flex w-full space-x-2">
          <Text className="text-gray-700">Your sites</Text>
        </div>
      </div>

      <FormMessage>{fieldState.error?.message}</FormMessage>
    </div>
  );
}
